import Link from "../Link";

const Typescript = () => {
    return (
        <div>
            <Link url="https://campus.open-bootcamp.com/cursos/25" title={"OpenBootcamp TypeScript"} />
        </div>
    );
}

export default Typescript;